export interface Board {
  id: number;
  name: string;
  icon: string;
  desc: string;
  posts: number;
  today: number;
  hot: boolean;
}

export interface Reply {
  id: number;
  author: string;
  time: string;
  text: string;
  likes: number;
}

export interface Post {
  id: number;
  title: string;
  boardId: number;
  board: string;
  author: string;
  time: string;
  replies: number;
  views: number;
  tags: string[];
  pinned?: boolean;
  hot?: boolean;
  excerpt: string;
  content: string[];
  repliesList: Reply[];
}

export interface Topic {
  id: number;
  title: string;
  category: string;
  summary: string;
  reads: number;
  date: string;
  body: string[];
}

export interface FaqItem {
  q: string;
  a: string;
}

export const boards: Board[] = [
  {
    id: 1,
    name: '热血打斗区',
    icon: 'ri-fire-fill',
    desc: '燃系战斗番聚集地，讨论打斗场面、能力设定与热血名场面。',
    posts: 4280,
    today: 136,
    hot: true,
  },
  {
    id: 2,
    name: '恋爱日常区',
    icon: 'ri-heart-fill',
    desc: '恋爱番、校园日常、治愈系作品，聊聊糖分与心动瞬间。',
    posts: 3561,
    today: 98,
    hot: true,
  },
  {
    id: 3,
    name: '悬疑推理区',
    icon: 'ri-spy-fill',
    desc: '烧脑推理与反转剧情，欢迎带脑洞来讨论伏笔和线索。',
    posts: 1820,
    today: 47,
    hot: false,
  },
  {
    id: 4,
    name: '搞笑吐槽区',
    icon: 'ri-emotion-laugh-fill',
    desc: '沙雕日常与搞笑神作，笑点密集，欢迎整活接龙。',
    posts: 2709,
    today: 63,
    hot: false,
  },
  {
    id: 5,
    name: '新番速递',
    icon: 'ri-movie-2-fill',
    desc: '每月新番前瞻、开播资讯与扫雷安利，第一时间掌握。',
    posts: 940,
    today: 51,
    hot: true,
  },
  {
    id: 6,
    name: '漫画单行本',
    icon: 'ri-book-3-fill',
    desc: '追更漫画、单行本评测与画风讨论，漫画党的根据地。',
    posts: 1520,
    today: 38,
    hot: false,
  },
];

export const hotTags = [
  '海贼王',
  '咒术回战',
  '鬼灭之刃',
  '夏目友人帐',
  '葬送的芙莉莲',
  '进击的巨人',
  '孤独摇滚',
  '青春猪头少年',
  '间谍过家家',
  '我推的孩子',
  '银魂',
  '排球少年',
];

export const posts: Post[] = [
  {
    id: 1,
    title: '《海贼王》最终章这个伏笔也太狠了，答案其实早就藏在十年前',
    boardId: 1,
    board: '热血打斗区',
    author: '草帽船长',
    time: '2小时前',
    replies: 186,
    views: 4820,
    tags: ['海贼王', '剧情解析', '伏笔'],
    pinned: true,
    hot: true,
    excerpt: '回看十年前的和之国篇，很多看似不起眼的对话原来都是最终章的关键线索。',
    content: [
      '最近重刷《海贼王》时突然发现，尾田老师埋的伏笔比想象中要深得多。尤其是和之国篇里某段看起来平平无奇的对话，放到最终章的剧情背景下再看，简直让人头皮发麻。',
      '很多人以为这部作品只是热血冒险，但实际上从最初就开始铺垫的世界观设定，在最终章陆续收束。想和大家一起讨论那些被忽略的细节，也欢迎拿出证据来反驳我的猜测。',
      '目前我能确定的一个点是：草帽一伙和古代王国之间的关联远不止表面上那么简单。欢迎大家各抒己见，理性讨论，尽量别剧透漫画最新话的具体内容。',
    ],
    repliesList: [
      { id: 1, author: '见闻色老粉', time: '1小时前', text: '我也回看了，那个镜头真的处处是戏，尾田的回收能力没得说。', likes: 34 },
      { id: 2, author: '航海日志', time: '48分钟前', text: '楼主分析到点子上了，不过建议把剧透打码，追漫画的小伙伴还挺多的。', likes: 21 },
      { id: 3, author: '乌索普吹', time: '30分钟前', text: '十年伏笔回收这件事本身就很燃，海贼王真是值得反复看。', likes: 17 },
    ],
  },
  {
    id: 2,
    title: '新番《夏目友人帐》第七季开播，每一帧都能当壁纸',
    boardId: 5,
    board: '新番速递',
    author: '妖怪观察员',
    time: '3小时前',
    replies: 92,
    views: 3210,
    tags: ['夏目友人帐', '新番', '治愈'],
    hot: true,
    excerpt: '熟悉的配乐、温柔的画面，第七季一开播就把治愈氛围拉满。',
    content: [
      '等了好久的第七季终于开播，第一集的水准依旧在线，画面细腻得每一帧都能截图当壁纸。背景配乐一响起来，那种熟悉的温暖感就回来了。',
      '这一季的妖怪故事似乎比以往更贴近人与人之间的羁绊，也更有深意。个人非常喜欢这种在平静中慢慢发酵的叙事节奏。',
      '如果你还没看过这部作品，强烈建议从第一季开始补，它绝对值得慢慢品味。看完第七季的朋友也可以来聊聊这季最喜欢的单元回。',
    ],
    repliesList: [
      { id: 1, author: '猫猫老师', time: '2小时前', text: '第一集看哭了，夏目永远的神，配乐也一如既往地好哭。', likes: 45 },
      { id: 2, author: '绿川幸粉', time: '1小时前', text: '画面制作真的顶，每一帧都是享受，强烈推荐。', likes: 28 },
    ],
  },
  {
    id: 3,
    title: '求安利：节奏慢、氛围治愈的日常漫，最好不要太刀',
    boardId: 2,
    board: '恋爱日常区',
    author: '保温杯少女',
    time: '5小时前',
    replies: 143,
    views: 2890,
    tags: ['安利', '日常漫', '治愈'],
    hot: true,
    excerpt: '最近被刀怕了，想找几部没有刀片、看完能安心睡个好觉的治愈日常作品。',
    content: [
      '最近连着追了几部结局都带刀片的作品，整个人被刀麻了。现在只想找一些节奏慢、氛围治愈、看完能安心睡觉的日常漫回回血。',
      '要求不算高：剧情轻松一点，画风舒服一点，男女主甜甜的但不要太折腾，最好没有任何刀片风险。',
      '评论区安利的我都记在小本本上了，先谢过各位同好。也欢迎一起聊聊那些让你反复重刷的治愈神作。',
    ],
    repliesList: [
      { id: 1, author: '糖分补给站', time: '4小时前', text: '强推《跃动青春》，又暖又治愈，看完心情超好。', likes: 52 },
      { id: 2, author: '番剧手账', time: '3小时前', text: '《相合之物》也很棒，日常里全是温柔，绝对无刀。', likes: 39 },
      { id: 3, author: '甜甜圈同学', time: '2小时前', text: '收藏了，最近正好剧荒，这楼含金量很高。', likes: 15 },
    ],
  },
  {
    id: 4,
    title: '《咒术回战》最新话情报讨论（含剧透，慎入）',
    boardId: 1,
    board: '热血打斗区',
    author: '领域展开',
    time: '8小时前',
    replies: 267,
    views: 6100,
    tags: ['咒术回战', '情报', '剧透'],
    hot: true,
    excerpt: '最新话的情报已经出来了，战斗场面依旧炸裂，但剧情走向争议很大。',
    content: [
      '这周的情报已经流出，战斗部分依旧让人热血沸腾，不过某些剧情安排争议很大，评论区已经吵成一团了。',
      '我个人对主角团现在的处境比较担忧，作者在塑造危机感方面从来不留情面。具体内容涉及剧透，没看的朋友建议跳过本楼。',
      '想听听大家怎么看接下来的走向，也欢迎对情报内容进行理性讨论，人身攻击一律拉黑。',
    ],
    repliesList: [
      { id: 1, author: '五条学生', time: '7小时前', text: '这发展真的没想到，不过打戏画得是真爽。', likes: 60 },
      { id: 2, author: '宿傩吹', time: '6小时前', text: '别吵了，等正式版出来再评价也不迟。', likes: 19 },
    ],
  },
  {
    id: 5,
    title: '最近在追的冷门神作，忍不住想安利给所有人',
    boardId: 4,
    board: '搞笑吐槽区',
    author: '自来水联盟',
    time: '昨天',
    replies: 110,
    views: 2040,
    tags: ['冷门神作', '安利', '搞笑'],
    excerpt: '一部几乎没什么人提的冷门搞笑番，结果意外地好看，强烈安利。',
    content: [
      '这部番热度低得可怜，但质量真的没话说，尤其是节奏和笑点都拿捏得很准，属于那种看了第一集就停不下来的类型。',
      '很多冷门作品其实都藏在角落里发光，只是缺少一个被发现的契机。如果你也喜欢那种不按套路出牌的搞笑风格，这部千万别错过。',
      '为了避免剧透我就不说名字了，感兴趣的朋友可以在评论区猜一猜，猜到我就揭晓答案。',
    ],
    repliesList: [
      { id: 1, author: '番剧考古家', time: '昨天', text: '盲猜是那部！这部确实被埋没了，支持。', likes: 33 },
      { id: 2, author: '冷门猎人', time: '昨天', text: '收藏了，回头去补，冷门番爱好者集合！', likes: 25 },
    ],
  },
  {
    id: 6,
    title: '动漫里的神级配乐合集，单曲循环停不下来',
    boardId: 4,
    board: '搞笑吐槽区',
    author: '耳机重度患者',
    time: '昨天',
    replies: 156,
    views: 3980,
    tags: ['配乐', 'OST', '歌单'],
    excerpt: '整理了这些年听过的最顶的动漫配乐，有些前奏一响DNA就动了。',
    content: [
      '作为一个耳机不离身的人，动漫配乐几乎是我歌单的半壁江山。这次整理了一份这些年听过最顶的OST，有的前奏一响DNA就开始动了。',
      '配乐是动漫的灵魂之一，好的配乐能瞬间把情绪拉满。这份歌单既有热血激昂的，也有安静治愈的，基本覆盖了各种心情。',
      '欢迎在评论区补充你心中的神级配乐，我会持续更新这份歌单。',
    ],
    repliesList: [
      { id: 1, author: '音轨收集者', time: '昨天', text: '必有一首是《火影》的！前奏一响我直接哭。', likes: 41 },
      { id: 2, author: '循环播放中', time: '10小时前', text: '歌单收藏了，通勤路上就靠这些了。', likes: 22 },
    ],
  },
];

export const topics: Topic[] = [
  {
    id: 1,
    title: '热血番十年进化史：从王道热血到群像叙事',
    category: '专题研究',
    summary: '梳理近十年热血番在叙事结构上的演变，聊聊我们为什么依然为它热血沸腾。',
    reads: 12800,
    date: '2026-07-28',
    body: [
      '热血番陪伴了一代人成长，从早期的王道热血到如今的群像叙事，它在悄然进化。战斗不再只是力量的比拼，而成为角色意志与信念的碰撞。',
      '我们看到的不是套路化的升级打怪，而是越来越复杂的世界观和越来越立体的人物群像。这些变化让热血番在商业与口碑之间找到了新的平衡。',
      '无论如何演变，那股「因为相信所以绝不放弃」的内核始终没有变，这大概就是热血番长盛不衰的原因。',
    ],
  },
  {
    id: 2,
    title: '治愈系动漫为何总能让成年人破防',
    category: '情感洞察',
    summary: '在快节奏的日常里，治愈系动漫用温柔抚平焦虑，聊聊它戳中我们的那些瞬间。',
    reads: 9600,
    date: '2026-07-15',
    body: [
      '成年人的世界总有疲惫，治愈系动漫正是靠着这份恰到好处的温柔，一次次接住我们的情绪。它不激烈、不冲突，却最擅长在细枝末节里打动人。',
      '那些平凡的小确幸、笨拙却真诚的羁绊，往往比宏大叙事更让人破防。我们需要的不是被拯救，而是被理解与被陪伴。',
      '治愈系作品正在成为许多人深夜的精神避难所，这或许就是它持续走红的社会情绪背景。',
    ],
  },
  {
    id: 3,
    title: '新番扫雷：2026 夏季新番清单与首波口碑',
    category: '新番速递',
    summary: '2026 夏季新番前瞻与首波口碑整理，帮你在剧荒时精准找到想看的那一部。',
    reads: 15300,
    date: '2026-07-02',
    body: [
      '夏季新番已经陆续开播，这一季的题材相当丰富，从热血战斗到日常治愈应有尽有。为了避免踩雷，我们整理了首波口碑供大家参考。',
      '其中几部续作表现稳定，延续了此前的制作水准；也有几部黑马原作意外地出彩，值得重点关注。',
      '具体名单和建议已在文中列出，方便你在剧荒时快速找到适合自己的那一部。',
    ],
  },
];

export const faqs: FaqItem[] = [
  {
    q: '羞羞动漫社是一个什么样的社区？',
    a: '羞羞动漫社是一个面向动漫、漫画同好群体的中文讨论交流社区，大家在这里分享追番心得、讨论剧情走向、安利作品，并寻找志同道合的朋友一起追更。',
  },
  {
    q: '加入社区需要付费吗？',
    a: '完全免费。注册账号后即可浏览板块、参与讨论、发帖回帖。我们希望能让更多同好轻松加入，一起畅所欲言。',
  },
  {
    q: '如何开始参与话题讨论？',
    a: '你可以在「讨论社区」页面选择感兴趣的板块，进入任意帖子后即可查看内容并发表回复，也可以直接发布新帖开启属于自己的话题。',
  },
  {
    q: '社区里有新番和漫画资讯吗？',
    a: '有。我们设有「新番速递」和「漫画单行本」等板块，会持续更新新番前瞻、开播资讯、漫画追更与单行本评测等内容。',
  },
  {
    q: '遇到不友善的内容或用户怎么办？',
    a: '我们倡导友善、理性的交流氛围。如遇违规内容，可通过「联系我们」页面反馈，工作人员核实后会及时处理。',
  },
];